import { render, staticRenderFns } from "./TypeDetail.vue?vue&type=template&id=449a4a4b&scoped=true"
import script from "./TypeDetail.vue?vue&type=script&lang=ts"
export * from "./TypeDetail.vue?vue&type=script&lang=ts"
import style0 from "./TypeDetail.vue?vue&type=style&index=0&id=449a4a4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a4a4b",
  null
  
)

export default component.exports